export default {
  registerFormLoading: false,
  registerFormError: null,
  clientRegisterForm: {
    first_name: null,
    last_name: null,
    phone: null,
    email: null,
    password1: null,
    password2: null,
    account: null
  },
  candidateRegisterForm: {
    referral_code: null,
    full_name: null,
    email: null,
    phone: null,
    verification_code: null,
    password1: null,
    password2: null,
    analytics: null,
    external_id: null,
    reg_id: null
  }
};
